import HeaderOther from "./header-other";

export default function TermsAndConditions() {

    return (
        <>
            <HeaderOther />
            <div style={{margin:'10px'}}>
                <p style={{fontSize:'24px'}}>Terms and Conditions for OnTimeUrban: The Instant Wholesaler</p>
                <p style={{fontSize:'16px', fontWeight:'500'}}>Effective Date: January 15, 2025</p>
                <p style={{fontSize:'14px'}}>
                    Welcome to OnTimeUrban! By using our website, mobile application, or services, you agree to
                    comply with the following Terms and Conditions. Please read them carefully before accessing
                    or using our platform.
                </p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Introduction</p>
                <p style={{ fontSize: '14px' }}>OnTimeUrban is a platform that sells grocery items, gadgets, and daily needs,
                    offering delivery within 15 minutes in Hazaribagh, Jharkhand. These Terms govern your use of our services.</p>
                
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Eligibility</p>
                <p style={{fontSize:'14px'}}>To use our services, you must:</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Be at least 18 years old or have parental consent.</li>
                    <li>Provide accurate and complete information during registration.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Account Registration</p>
                <ul style={{fontSize:'14px'}}>
                    <li>You are responsible for maintaining the confidentiality of your account credentials.</li>
                    <li>Notify us immediately of any unauthorized access to your account.</li>
                    <li>OnTimeUrban reserves the right to suspend or terminate accounts for fraudulent or unauthorized activities.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Placing Orders</p>
                <ul style={{ fontSize: '14px' }}>
                    <li>Orders can be placed via our website or mobile application.</li>
                    <li>Availability of products is subject to stock levels.</li>
                    <li>Orders are processed only after successful payment confirmation.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Pricing and Payment</p>
                <p style={{ fontSize: '14px' }}>You have the right to:</p>
                <ul style={{ fontSize: '14px' }}>
                    <li>All prices are displayed in INR and include applicable taxes.</li>
                    <li>Payment methods include credit/debit cards, UPI, and other available options.</li>
                    <li>OnTimeUrban reserves the right to modify prices without prior notice.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Delivery Policy</p>
                <ul style={{ fontSize: '14px' }}>
                    <li>Delivery is available exclusively in Hazaribagh, Jharkhand.</li>
                    <li>We aim to deliver orders within 15 minutes of confirmation.</li>
                    <li>Delays may occur due to unforeseen circumstances, such as weather or traffic conditions.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Cancellation and Refunds</p>
                <p style={{ fontSize: '14px', fontWeight: '500' }}>a. Cancellation</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Orders can be canceled before they are dispatched.</li>
                    <li>OnTimeUrban reserves the right to cancel orders due to stock unavailability or payment issues.</li>
                </ul>
                <p style={{ fontSize: '14px', fontWeight: '500' }}>b. Refunds</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Refunds for canceled orders will be processed within 7 working days.</li>
                    <li>Refunds will be credited to the original payment method.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Product Returns and Replacements</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Returns are accepted for damaged or defective products within 48 hours of delivery.</li>
                    <li>Replacements are subject to product availability.</li>
                    <li>To initiate a return or replacement, contact our support team with proof of purchase.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Prohibited Activities</p>
                <p style={{ fontSize: '14px' }}>When using our services, you agree not to:</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Engage in fraudulent activities or provide false information.</li>
                    <li>Use our platform for illegal or unauthorized purposes.</li>
                    <li>Interfere with the operation of our website, app, or services.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Intellectual Property</p>
                <ul style={{fontSize:'14px'}}>
                    <li>All content on OnTimeUrban’s platform, including logos, text, images, and
                        designs, is protected by copyright and trademark laws.</li>
                    <li>Unauthorized use of our intellectual property is prohibited.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Limitation of Liability</p>
                <p style={{fontSize:'14px'}}>OnTimeUrban is not liable for:</p>
                <ul style={{fontSize:'14px'}}>
                    <li>Delays in delivery caused by factors beyond our control.</li>
                    <li>Loss or damage arising from unauthorized account access.</li>
                    <li>Indirect, incidental, or consequential damages.</li>
                </ul>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Indemnification</p>
                <p style={{fontSize:'14px'}}>You agree to indemnify and hold OnTimeUrban harmless from any claims, damages,
                    or expenses arising from your use of our services or violation of these Terms.</p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Modification of Terms</p>
                <p style={{ fontSize: '14px' }}>OnTimeUrban reserves the right to update or modify these Terms at any time.
                    Changes will be posted on this page, and your continued use of our services constitutes acceptance of
                    the updated Terms.</p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Governing Law and Jurisdiction</p>
                <p style={{ fontSize: '14px' }}>These Terms are governed by the laws of India. Any disputes
                    will be resolved exclusively in the courts of Hazaribagh, Jharkhand.</p>
                <p style={{ fontSize: '16px', fontWeight: '500' }}>Contact Us</p>
                <p style={{ fontSize: '14px' }}>If you have any questions or concerns about this Terms And Conditions, please contact us at:</p>
                <p style={{ fontSize: '14px', fontWeight: '500' }}>OnTimeUrban: The Instant Wholesaler</p>
                <p style={{ fontSize: '14px' }}><span style={{ fontWeight: '500' }}>Email:</span> ontimeurban@gmail.com</p>
                <p style={{ fontSize: '14px' }}><span style={{ fontWeight: '500' }}>Phone:</span> +91-7481016483</p>
                <p style={{ fontSize: '14px' }}><span style={{ fontWeight: '500' }}>Address:</span> Hazaribagh, Jharkhand, India</p>
            </div>
        </>
    );
}